import React, { useState } from "react";
import { Table, Tag, Checkbox, Tooltip, Button } from "antd";
import {
  FaUserFriends,
  FaMapMarkerAlt,
  FaTruck,
  FaStar,
  FaEdit,
} from "react-icons/fa";
import {
  CheckOutlined,
  WarningOutlined,
  WifiOutlined,
} from "@ant-design/icons";
import { RiSteering2Line } from "react-icons/ri";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
dayjs.locale("fr");
export default function PlanifTable({
  data,
  contactBureau,
  showPopup,
  updateData,
  selectedRowKeys,
  setModalMessageVisible,
  setModalRecord,
  updateSelection,
  selectAll,
  disabled,
}) {
  const columns = [
    {
      dataIndex: "status",
      width: 50,
      key: "status",
      render: (status) =>
        status ? (
          status?.type === "error" ? (
            <Tooltip title={status.message} placement="right">
              {StatusIcon(status.type)}
            </Tooltip>
          ) : (
            StatusIcon(status)
          )
        ) : null,
    },
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.nom.localeCompare(b.nom),
      width: 150,
    },
    {
      title: "Prénom",
      dataIndex: "prenom",
      key: "prenom",
      sorter: (a, b) => a.prenom.localeCompare(b.prenom),
      width: 150,
    },
    {
      title: "Projets",
      dataIndex: "projects",
      key: "projects",
      render: (projects) => (
        <>
          {projects.map((project, index) => {
            let color = getColor(project);
            if (project === "OFF") {
              return (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    margin: 10,
                    backgroundColor: color.background,
                    border: `1px solid ${color.border}`,
                    borderRadius: 3,
                    color: color.color,
                  }}
                >
                  <div>
                    <span style={{ fontWeight: "bold" }}>OFF</span>
                  </div>
                </div>
              );
            }
            if (project === "CONGÉ") {
              return (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    margin: 10,
                    backgroundColor: color.background,
                    border: `1px solid ${color.border}`,
                    borderRadius: 3,
                    color: color.color,
                  }}
                >
                  <div>
                    <span style={{ fontWeight: "bold" }}>CONGÉ</span>
                  </div>
                </div>
              );
            }
            let phonenumberchargedeprojets;
            let indexphonenumber = contactBureau.findIndex(
              (contact) =>
                project.chargedeprojet === contact.prenom + " " + contact.nom
            );
            phonenumberchargedeprojets =
              contactBureau[indexphonenumber].phonenumber;
            return (
              <div
                key={index}
                //color={getColor(project).color}
                style={{
                  //marginTop: index > 0 ? '5px' : '0px',
                  padding: 10,
                  margin: 10,
                  backgroundColor: color.background,
                  border: `1px solid ${color.border}`,
                  borderRadius: 3,
                  color: color.color,
                }}
              >
                {project.remarques !== "ANNULÉ" && (
                  <div>
                    <span style={{ fontWeight: "bold" }}>Projet : </span>
                    <span style={{ flexWrap: "wrap" }}>
                      {project.projectname}
                    </span>
                  </div>
                )}
                <div>
                  <span style={{ fontWeight: "bold" }}>Départ : </span>
                  <span
                    style={{
                      fontWeight:
                        project.remarques === "ANNULÉ" ? "bold" : "inherit",
                      color: project.remarques === "ANNULÉ" ? "red" : "inherit",
                    }}
                  >
                    {project.remarques === "ANNULÉ"
                      ? "ANNULÉ"
                      : dayjs(project.depart, "HH:mm").format("HH:mm A") +
                        (project.remarques.trim().length > 2
                          ? " - " + project.remarques
                          : "")}
                  </span>
                </div>
                <div>
                  <span style={{ fontWeight: "bold" }}>
                    Chargé de projets :{" "}
                  </span>
                  <span>
                    {project.chargedeprojet + " " + phonenumberchargedeprojets}
                  </span>
                </div>
                {project.remarques !== "ANNULÉ" && (
                  <>
                    <div>
                      <span style={{ fontWeight: "bold" }}>Camion : </span>
                      <span>{project.numerocamion}</span>
                      <span style={{ fontWeight: "bold", marginLeft: 10 }}>
                        Chauffeur :{" "}
                      </span>
                      <span>{project.chauffeur ? "Oui" : "Non"}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>
                        Contremaître :{" "}
                      </span>
                      <span>{project.contremaitre ? "Oui" : "Non"}</span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "bold" }}>Équipe : </span>
                      {getCollegues(project).map(
                        (collegue, index, collegues) => (
                          <span key={index}>
                            {collegue}
                            {collegues.length - 1 - index > 0 ? ", " : ""}
                          </span>
                        )
                      )}
                    </div>
                  </>
                )}
                {/* {project.remarques.trim().length > 2 && (
                  <div>
                    <span style={{ fontWeight: 'bold' }}>Remarques : </span>
                    <span>{project.remarques}</span>
                  </div>
                )} */}
              </div>
            );
          })}
        </>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Tooltip title="Avertir l'employé du projet?">
            <FaMapMarkerAlt />
          </Tooltip>
        </div>
      ),
      dataIndex: "direprojet",
      //width: '10%',
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: "center" }}>
          <Checkbox
            disabled={record.manualmessage || disabled}
            checked={value}
            onChange={() => updateData(record, "direprojet", value)}
          />
        </div>
      ),
      width: 50,
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Tooltip title="Avertir l'employé du camion?">
            <FaTruck />
          </Tooltip>
        </div>
      ),
      dataIndex: "direcamion",
      //width: '10%',
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: "center" }}>
          <Checkbox
            disabled={record.manualmessage || disabled}
            checked={value}
            onChange={() => updateData(record, "direcamion", value)}
          />
        </div>
      ),
      width: 50,
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Tooltip title="Avertir l'employé s'il est le chauffeur?">
            <RiSteering2Line />
          </Tooltip>
        </div>
      ),
      dataIndex: "direchauffeur",
      //width: '10%',
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: "center" }}>
          <Checkbox
            disabled={record.manualmessage || disabled}
            checked={value}
            onChange={() => updateData(record, "direchauffeur", value)}
          />
        </div>
      ),
      width: 50,
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Tooltip title="Avertir l'employé s'il est contremaître?">
            <FaStar />
          </Tooltip>
        </div>
      ),
      dataIndex: "direchefequipe",
      //width: '10%',
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: "center" }}>
          <Checkbox
            disabled={record.manualmessage || disabled}
            checked={value}
            onChange={() => updateData(record, "direchefequipe", value)}
          />
        </div>
      ),
      width: 50,
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <Tooltip title="Avertir l'employé des membres de l'équipe?">
            <FaUserFriends />
          </Tooltip>
        </div>
      ),
      dataIndex: "direequipe",
      //width: '10%',
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: "center" }}>
          <Checkbox
            disabled={record.manualmessage || disabled}
            checked={value}
            onChange={() => updateData(record, "direequipe", value)}
          />
        </div>
      ),
      width: 50,
    },

    {
      dataIndex: "message",
      render: (value, record, rowIndex) => (
        <div style={{ textAlign: "center" }}>
          <Tooltip
            placement="left"
            title={record.message}
            overlayStyle={{
              whiteSpace: "pre-line",
              maxWidth: 600,
            }}
          >
            <Button
              icon={<FaEdit />}
              disabled={disabled}
              onClick={() => {
                setModalRecord(record);
                setModalMessageVisible(true);
                //console.log(record);
              }}
            />
          </Tooltip>
        </div>
      ),
      width: 65,
    },
  ];
  const rowSelection = {
    type: "checkbox",
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(
      //   `selectedRowKeys: ${selectedRowKeys}`,
      //   'selectedRows: ',
      //   selectedRows
      // );
    },
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      updateSelection(record.key, selected);
    },
    onSelectAll: selectAll,
    onSelectInvert: (selectedRowKeys) => {
      console.log("onSelectInvert");
    },
    onSelectNone: () => {
      console.log("onSelectNone");
    },
    getCheckboxProps: (record) => ({
      disabled: disabled,
      // Column configuration not to be checked
      //name: record.name,
    }),
  };
  const onRow = (record) => ({
    onContextMenu: (event) => {
      event.preventDefault();
      // if (!this.state.visible) {
      //   const that = this;
      //   document.addEventListener(`click`, function onClickOutside() {
      //     //that.setState({popup: {visible: false}})
      //     document.removeEventListener(`click`, onClickOutside);
      //   });
      // }
      //console.log(event);
      //showPopup(record, event.clientX, event.clientY);
    },
  });
  const StatusIcon = (status) => {
    return status === "loading" ? (
      <WifiOutlined style={{ color: "orange" }} />
    ) : //'loading'
    status === "accepted" ? (
      <CheckOutlined style={{ color: "green" }} />
    ) : //'sent'
    status === "error" ? (
      <WarningOutlined style={{ color: "red" }} />
    ) : (
      //'error'
      ""
    );
  };
  return (
    <Table
      pagination={false}
      bordered
      columns={columns}
      dataSource={data}
      rowSelection={rowSelection}
      onRow={onRow}
      sticky
      //scroll={{ y: 'calc(100vh - 300px)' }}
    />
  );
}

function getColor(project) {
  if (project.remarques === "OUT") {
    return { background: "#fff7e6", border: "#ffd591", color: "#d46b08" };
  }
  switch (project.depart) {
    case "17:30":
    case "18:00":
    case "18:30":
    case "19:00":
    case "19:30":
    case "20:00":
    case "20:30":
    case "21:00":
    case "21:30":
    case "22:00":
    case "22:30":
    case "23:00":
    case "23:30":
    case "00:00":
    case "00:30":
    case "01:00":
    case "01:30":
    case "02:00":
    case "02:30":
    case "03:00":
    case "03:30":
    case "04:00":
    case "04:30":
      return { background: "#f6ffed", border: "#b7eb8f", color: "#389e0d" };
    case "05:00":
    case "05:30":
    case "06:00":
    case "06:30":
    case "07:00":
    case "07:30":
    case "08:00":
    case "08:30":
    case "09:00":
    case "09:30":
    case "10:00":
    case "10:30":
    case "11:00":
    case "11:30":
    case "12:00":
    case "12:30":
    case "13:00":
    case "13:30":
    case "14:00":
    case "14:30":
    case "15:00":
    case "15:30":
    case "16:00":
    case "16:30":
    case "17:00":
      return { background: "#ffffc7", border: "#eded00", color: "#8c7e00" };
  }
  switch (project) {
    case "CONGÉ":
      return { background: "#e6f7ff", border: "#91d5ff", color: "#096dd9" };
    case "OFF":
      return { background: "#fff0f6", border: "#ffadd2", color: "#c41d7f" };
  }
}
function getCollegues(project) {
  let collegues = [];
  project.collegues.map((camion) => {
    if (camion.remarques !== "ANNULÉ") {
      camion.passagers.map((passager) => {
        collegues.push(
          passager.prenom +
            " " +
            passager.nom.charAt(0).toUpperCase() +
            "." +
            (passager.contremaitre ? " (Contremaître)" : "")
        );
      });
    }
  });
  return collegues;
}
